// src/services/instructorApi.js
const API_BASE =
  (typeof import.meta !== "undefined" &&
    import.meta.env?.VITE_API_BASE?.replace(/\/+$/, "")) ||
  (process.env.REACT_APP_API_BASE &&
    process.env.REACT_APP_API_BASE.replace(/\/+$/, "")) ||
  "http://localhost:5050";

async function req(path, { method = "GET", token, body } = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: "include",
    body: body ? JSON.stringify(body) : undefined,
  });

  const ct = res.headers.get("content-type") || "";
  const data = ct.includes("application/json")
    ? await res.json().catch(() => ({}))
    : null;

  if (!res.ok) {
    const msg = (data && (data.error || data.message)) || `HTTP ${res.status}`;
    throw new Error(msg);
  }

  return data;
}

/**
 * Learners for instructor (server resolves church mapping)
 * Backend returns: { ok: true, data: [...] } (likely)
 */
export async function getInstructorLearners(token, churchId) {
  const q = new URLSearchParams();
  // Align query param name with backend: ?church_id=...
  if (churchId) q.set("church_id", String(churchId));
  const qs = q.toString() ? `?${q.toString()}` : "";

  return req(`/api/instructor/learners${qs}`, { token });
}

/**
 * Queue a reminder to a learner
 *
 * Supports BOTH call styles:
 *  1) sendReminder(token, learnerId, message?)
 *  2) sendReminder(token, { learnerId, message? })
 */
export async function sendReminder(token, learnerIdOrPayload, message) {
  const payload =
    learnerIdOrPayload && typeof learnerIdOrPayload === "object"
      ? learnerIdOrPayload
      : {
          learnerId: learnerIdOrPayload,
          ...(message ? { message } : {}),
        };

  if (!payload?.learnerId) {
    throw new Error("learnerId is required");
  }

  return req(`/api/instructor/reminders`, {
    method: "POST",
    token,
    body: payload,
  });
}
